import OCRPage from './OCRPage';

export default OCRPage;
